import React from 'react';
import PulseLoader from "react-spinners/PulseLoader";
import './ModalLoad.css';

export default function ModalLoad({ option }) {
    return (
        <div className='modal-loading-overlay print-disable'>
            <div className='modal-loading'>
                <div className="modal-loading-body text-center" >
                    <div className="modal-loading-header">Please wait...</div>
                    <div className="modal-loading-content mb-5">{option?.message}</div>
                    <PulseLoader
                        strokecolor="grey"
                        strokeWidth="3"
                        animationduration="0.75"
                        width="50"
                        color="#3498db"
                        visible={"true"} />
                </div>
            </div>
        </div>
    )
}
